import React, {ReactNode} from 'react'
import {IconButton, Stack, Tooltip} from "@mui/material"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import {TOP_NAV_HEIGHT, SIDEBAR_WIDTH, SIDEBAR_WIDTH_COLLAPSED} from "./layoutConstants"
import {useSidebarCollapsed} from "../../hooks/useCollapsible"

interface SidebarShellProps {
    children: (collapsed: boolean) => ReactNode
}

function SidebarShell({children}: SidebarShellProps) {
    const [collapsed, toggleCollapsed] = useSidebarCollapsed()

    const width = collapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH

    return (
        <Stack
            sx={{
                width,
                height: `calc(100vh - ${TOP_NAV_HEIGHT}px)`,
                position: 'fixed',
                top: `${TOP_NAV_HEIGHT}px`,
                left: 0,
                bgcolor: '#fff',
                px: collapsed ? 1 : 3,
                py: 4,
                boxSizing: 'border-box',
                zIndex: 999,
                transition: 'width 200ms ease, padding 200ms ease',
                overflow: 'hidden',
            }}
        >
            <Stack sx={{flex: 1, justifyContent: 'space-between'}}>
                {children(collapsed)}
            </Stack>

            <Tooltip title={collapsed ? "Expand sidebar" : "Collapse sidebar"} placement="right">
                <IconButton
                    onClick={toggleCollapsed}
                    size="small"
                    sx={{
                        mt: 3,
                        color: '#999',
                        alignSelf: 'flex-start',
                        ml: collapsed ? 'auto' : 0,
                        mr: collapsed ? 'auto' : 0,
                        '&:hover': {color: '#555'},
                    }}
                >
                    {collapsed ? <ChevronRightIcon fontSize="small"/> : <ChevronLeftIcon fontSize="small"/>}
                </IconButton>
            </Tooltip>
        </Stack>
    )
}

export default SidebarShell
